import styled from "styled-components";

export const Divisor = styled.div`
    /* border-top: 2px solid black;
    border-bottom: 2px solid black;
    margin-bottom: 5px;
    height: 6px;
    width: 100%; */
`;

export const DotLine = styled.div`
    width: 100%;
    border-bottom: 1px dashed #777;
    margin-bottom: 10px;
    margin-top: 10px;
`;

export const Topic = styled.div`
    width: 100%;
    background-color: #d3d3d3;
    padding: 2.5px 2.5px 0px;
    margin-bottom: 2.5px;
`;
